import BaseService from '../core/service/BaseService';

const url = 'vinculos-propostas';
class VinculoPropostaService extends BaseService {}

export default new VinculoPropostaService(url);
